<script lang="ts">

	export let currentProgress: number = 0;
	export let completionGoal: number = 0;
	export let progressColor: string = '';
	export let icon: string = '';

	const initialAngle = 5;
	const completeAngle = 360;

	const progressSize = 68;
	let angle: number = initialAngle;
	if (currentProgress !== 0) {
		angle = completeAngle * (currentProgress / completionGoal);
	} else angle = initialAngle;


	$: cssVarStyles = `--color:${progressColor};--degrees:${angle}deg;--progressSize:${progressSize}px;`;
</script>

<div class="oc-mr-75 progress__container"
	data-testid="achievement-progress"
	aria-label={`Challenge-Fortschritt ${currentProgress} von ${completionGoal}`}>
	<div data-testid="progress-circle" class="progress__circle" style="{cssVarStyles}">
		<div class="oc-copy-75 circle-text">
			{#if icon}
				<oc-icon-v1 data-testid="progress-icon" type={icon} class="icon" size="100"></oc-icon-v1>
			{:else}
				{currentProgress}/{completionGoal}
			{/if}
		</div>
	</div>
</div>


<style lang="scss">
  $progressSize: var(--progressSize);
  .circle-text {
    display: flex;
    align-items: center;
  }


  .progress {
    &__container {
      align-self: flex-start;
    }

    &__circle {
      background: radial-gradient(white 56%, transparent 51%), conic-gradient(#E6E6E6 0deg, #E6E6E6 360deg);
      border-radius: 50%;
      width: $progressSize;
      aspect-ratio: 1;
      position: relative;
      place-content: center;
      display: flex;

      &:before {
        content: "";
        position: absolute;
        border-radius: 50%;
        inset: 0;
        background: radial-gradient(farthest-side, var(--color) 98%, #0000) top/8px 8px no-repeat,
        conic-gradient(var(--color) 0deg, var(--degrees), transparent var(--degrees) 360deg);
        mask: radial-gradient(farthest-side, #0000 calc(99% - 8px), #000 calc(100% - 8px));
      }

      &:after {
        content: "";
        position: absolute;
        border-radius: 50%;
        inset: calc(50% - 8px / 2);
        background: var(--color);
        transform: rotate(var(--degrees)) translateY(calc(50% - $progressSize / 2));
      }
    }


  }

</style>

